var _mask, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInformation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_857_6956",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.68 13.4134C17.2042 12.3895 17.5 11.2293 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5C11.2211 17.5 12.374 17.2082 13.3929 16.6905L17.5 18.3333L16.68 13.4134Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.68 13.4134L15.7899 12.9577L15.6393 13.2518L15.6936 13.5778L16.68 13.4134ZM13.3929 16.6905L13.7643 15.762L13.3437 15.5938L12.9399 15.799L13.3929 16.6905ZM17.5 18.3333L17.1286 19.2618L18.7785 19.9218L18.4864 18.1689L17.5 18.3333ZM16.5 10C16.5 11.0672 16.2436 12.0716 15.7899 12.9577L17.5701 13.8691C18.1649 12.7075 18.5 11.3914 18.5 10H16.5ZM10 3.5C13.5899 3.5 16.5 6.41015 16.5 10H18.5C18.5 5.30558 14.6944 1.5 10 1.5V3.5ZM3.5 10C3.5 6.41015 6.41015 3.5 10 3.5V1.5C5.30558 1.5 1.5 5.30558 1.5 10H3.5ZM10 16.5C6.41015 16.5 3.5 13.5899 3.5 10H1.5C1.5 14.6944 5.30558 18.5 10 18.5V16.5ZM12.9399 15.799C12.0581 16.247 11.0601 16.5 10 16.5V18.5C11.3821 18.5 12.6899 18.1694 13.8459 17.582L12.9399 15.799ZM17.8714 17.4049L13.7643 15.762L13.0215 17.619L17.1286 19.2618L17.8714 17.4049ZM15.6936 13.5778L16.5136 18.4977L18.4864 18.1689L17.6664 13.249L15.6936 13.5778Z",
    fill: "#202635",
    fillOpacity: 0.7,
    mask: "url(#path-1-inside-1_857_6956)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16666 7.36516V6.03516H10.5067V7.36516H9.16666ZM9.16666 13.3352V8.09516H10.5067V13.3352H9.16666Z",
    fill: "#202635",
    fillOpacity: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.d6fef6c6.svg";
export { ForwardRef as ReactComponent };